import { CustomOptionProps } from './index'

export const molineOptions: CustomOptionProps = {
  headerIsShown: true,
  hiddenLinks: [],
  links: [],
  buttons: {},
  customText: {},
  questionsList: {
    showCategoryName: false
  },
  videoThumbnails: {
    preferenceForNames: false
  },
  helpfulHintsEnabled: false
}
